import { LookingForOptionsType } from './types';

export const LOOKING_FOR_OPTIONS: LookingForOptionsType = [
  {
    id: 'first_time_trans',
    title: 'First time with a trans girl',
  },
  {
    id: 'role_switching',
    title: 'Role switching',
  },
  {
    id: 'dominant_rough',
    title: 'Dominant and rough',
  },
  {
    id: 'soft_playful',
    title: 'Soft and playful',
  },
];
